export default __webpack_public_path__ + "media/transfer_window/transfer_completed-2-f6e6ff06.gif";